(() => {
  if (window.__rk14Menu) return;
  window.__rk14Menu = true;

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  const menu = () => $('[data-rk4-mobile-menu]');
  const menuIsOpen = () => Boolean(menu()?.classList.contains('is-open'));
  const closeMenu = () => {
    if (menuIsOpen()) $('[data-rk4-mobile-close]', menu())?.click();
  };

  /* Legacy JS-injected blocks (favourites, product rail, confidence) are not wanted in the simplified mobile menu. */
  const stripBusyBlocks = () => {
    const root = menu();
    if (!root) return;
    $$('.rk4-mobile-menu__confidence, .rk9-menu-favorites, [data-rk9-product-rail="menu"], .rk4-mobile-menu__utilities, .rk4-mobile-menu__visuals', root).forEach(node => node.remove());
  };

  /* Chat launchers (Shopify Inbox) */
  const findInboxHost = () => $('#ShopifyChat') || $('shopify-chat') || $('inbox-online-store-chat');
  const openInbox = () => {
    const host = findInboxHost();
    if (!host) return false;
    const roots = [host, host.shadowRoot, $('inbox-online-store-chat')?.shadowRoot].filter(Boolean);
    for (const root of roots) {
      const button = root.querySelector('button, [role="button"]');
      if (button) { button.click(); return true; }
    }
    return false;
  };

  /* Support dialog */
  const dialog = () => $('[data-rk14-support]');
  let supportTrigger = null;
  const openSupport = trigger => {
    const el = dialog();
    if (!el || el.open) return;
    supportTrigger = trigger || null;
    const live = $('[data-rk14-live-chat]', el);
    if (live) live.hidden = !findInboxHost();
    if (typeof el.showModal === 'function') el.showModal();
    else el.setAttribute('open', '');
    document.documentElement.classList.add('rk14-support-open');
  };
  const closeSupport = (restore = true) => {
    const el = dialog();
    if (!el) return;
    if (el.open) el.close();
    document.documentElement.classList.remove('rk14-support-open');
    if (restore && supportTrigger && document.contains(supportTrigger) && supportTrigger.offsetParent) supportTrigger.focus({ preventScroll: true });
  };

  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const supportOpen = target.closest('[data-rk14-support-open]');
    if (supportOpen) {
      event.preventDefault();
      closeMenu();
      openSupport(null);
      return;
    }

    const supportClose = target.closest('[data-rk14-support-close]');
    if (supportClose) { closeSupport(!supportClose.matches('[data-rk4-size-finder-open]')); return; }

    if (target.closest('[data-rk14-live-chat-open]')) {
      closeSupport(false);
      window.setTimeout(openInbox, 60);
      return;
    }

    const el = dialog();
    if (el && target === el) { closeSupport(true); return; }

    /* Size finder launched from inside the menu: close the menu first. */
    if (target.closest('[data-rk4-mobile-menu] [data-rk4-size-finder-open]')) closeMenu();

    /* Dock SEPET: open the cart drawer when present, otherwise follow the /cart link. */
    const cartLink = target.closest('[data-rk14-cart-open]');
    if (cartLink) {
      const trigger = $('.rk4-header__cart [data-testid="cart-drawer-trigger"]') || $('cart-drawer-component [data-testid="cart-drawer-trigger"]');
      if (trigger) {
        event.preventDefault();
        closeMenu();
        trigger.click();
      }
    }
  });

  document.addEventListener('close', event => {
    if (event.target === dialog()) document.documentElement.classList.remove('rk14-support-open');
  }, true);

  /* Cart drawer open state -> html class (lets CSS hide the chat bubble). */
  const watchCart = () => {
    const cartDialog = $('.cart-drawer__dialog');
    if (!cartDialog || cartDialog.dataset.rk14Watched) return;
    cartDialog.dataset.rk14Watched = 'true';
    const sync = () => document.documentElement.classList.toggle('rk14-cart-open', cartDialog.open);
    new MutationObserver(sync).observe(cartDialog, { attributes: true, attributeFilter: ['open'] });
    sync();
  };

  /* Focus trap while the mobile menu is open (Escape/aria-expanded are handled in rk4.js). */
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !menuIsOpen()) return;
    const root = menu();
    const items = $$('a[href], button:not([disabled])', root).filter(node => node.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (!root.contains(document.activeElement)) { first.focus(); event.preventDefault(); }
    else if (event.shiftKey && document.activeElement === first) { last.focus(); event.preventDefault(); }
    else if (!event.shiftKey && document.activeElement === last) { first.focus(); event.preventDefault(); }
  });

  /* Announcement bar: markup is server-rendered (first message .is-active); JS only swaps the class every ~4s.
     Paused on hover/focus/hidden tab; prefers-reduced-motion keeps the first message only. */
  const reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  let annTimer = 0;
  const annItems = () => $$('[data-rk14-ann-item]');
  const annShow = index => {
    const items = annItems();
    items.forEach((item, i) => {
      const on = i === index;
      // Yukarı kayarak çıkan mesaj: kaydıktan sonra geçişsiz alta sıfırlanır (görünmeden)
      if (!on && item.classList.contains('is-active')) {
        item.classList.add('is-leaving');
        setTimeout(() => {
          item.style.transition = 'none';
          item.classList.remove('is-leaving');
          void item.offsetHeight;
          item.style.transition = '';
        }, 520);
      }
      item.classList.toggle('is-active', on);
      if (on) item.removeAttribute('aria-hidden'); else item.setAttribute('aria-hidden', 'true');
      $$('a', item).forEach(a => { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
    });
  };
  const annCurrent = () => Math.max(0, annItems().findIndex(item => item.classList.contains('is-active')));
  const annStop = () => { window.clearInterval(annTimer); annTimer = 0; };
  const annStart = () => {
    annStop();
    const items = annItems();
    if (items.length < 2 || reduceMotion.matches || document.hidden) return;
    annTimer = window.setInterval(() => annShow((annCurrent() + 1) % annItems().length), 4000);
  };
  const initAnnouncement = () => {
    const bar = $('[data-rk14-ann]');
    if (!bar) return;
    if (!bar.dataset.rk14AnnReady) {
      bar.dataset.rk14AnnReady = 'true';
      ['mouseenter', 'focusin', 'touchstart'].forEach(name => bar.addEventListener(name, annStop, { passive: true }));
      ['mouseleave', 'focusout'].forEach(name => bar.addEventListener(name, annStart));
      document.addEventListener('visibilitychange', () => (document.hidden ? annStop() : annStart()));
      if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', annStart);
    }
    if (!annItems().some(item => item.classList.contains('is-active'))) annShow(0);
    annStart();
  };
  /* Theme editor: show the selected message block. */
  document.addEventListener('shopify:block:select', event => {
    const items = annItems();
    const index = items.findIndex(item => item === event.target || item.contains(event.target));
    if (index > -1) { annStop(); annShow(index); }
  });
  document.addEventListener('shopify:block:deselect', annStart);

  /* Favourites toast: add a "Gör" action that opens the favourites panel (rk9-conversion.js handles [data-rk9-favorites-open]). */
  const initToastAction = () => {
    const toast = $('[data-rk4-toast]');
    if (!toast || toast.dataset.rk14Action) return;
    toast.dataset.rk14Action = 'true';
    new MutationObserver(() => {
      if (toast.querySelector('.rk4-toast__action')) return;
      const added = toast.textContent.trim() === 'FAVORİLERE EKLENDİ';
      toast.classList.toggle('has-action', added);
      if (!added) return;
      const label = document.createElement('span');
      label.textContent = toast.textContent.trim();
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rk4-toast__action';
      button.setAttribute('data-rk9-favorites-open', '');
      button.textContent = 'GÖR';
      toast.replaceChildren(label, button);
    }).observe(toast, { childList: true, characterData: true, subtree: true });
  };

  const init = () => {
    initAnnouncement();
    initToastAction();
    stripBusyBlocks();
    watchCart();
    const root = menu();
    if (root && !root.dataset.rk14Observed) {
      root.dataset.rk14Observed = 'true';
      new MutationObserver(stripBusyBlocks).observe(root, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();

/* Mobil "Numara bul" ipucu: ilk ziyarette bir kez, 6 sn görünür */
(() => {
  const KEY = 'rk14-size-tip-seen';
  const show = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const tip = document.querySelector('[data-rk14-size-tip]');
    if (!tip) return;
    try { if (localStorage.getItem(KEY)) return; localStorage.setItem(KEY, '1'); } catch (e) { return; }
    setTimeout(() => {
      tip.hidden = false;
      const hide = () => { tip.hidden = true; };
      setTimeout(hide, 6000);
      window.addEventListener('scroll', hide, { once: true, passive: true });
      tip.closest('button')?.addEventListener('click', hide, { once: true });
    }, 2500);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show, { once: true });
  else show();
})();

/* Performans: ekran dışındaki bölümlerde animasyonları duraklat (sonsuz döngüler boşuna çalışmasın) */
(() => {
  if (!('IntersectionObserver' in window)) return;
  const SEL = '.rk14-trust, .rk14-cats, .rk4-products, .rk4-reels, .rk14-reels-scope, .rk4-related, .rk4-footer';
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => e.target.classList.toggle('rk14-offscreen', !e.isIntersecting));
  }, { rootMargin: '120px 0px' });
  const watch = root => (root || document).querySelectorAll(SEL).forEach(el => {
    if (el.dataset.rk14Perf) return; el.dataset.rk14Perf = '1'; io.observe(el);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => watch(), { once: true });
  else watch();
  document.addEventListener('shopify:section:load', e => watch(e.target));
})();
